import React from 'react';

export default function Footer() {
  return(
    <footer>
      <h4>Copyright © 2020, Melissa Young</h4>
    </footer>
  );
};
